import React, { useState, useEffect } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Download, Code2 } from 'lucide-react';
// Generated by Copilot — Migrated from Userfront to Clerk
import useAuthHeaders from '../hooks/useAuthHeaders';
import './Consultar.css';

const Consultar = () => {
  const [displayToken, setDisplayToken] = useState('');
  const { userId, getToken } = useAuthHeaders();

  useEffect(() => {
    if (userId) {
      getToken().then(t => setDisplayToken(t || ''));
    }
  }, [userId, getToken]);

  const copyToken = async () => {
    const token = await getToken();
    navigator.clipboard.writeText(token);
  };

  const truncateToken = (token) => {
    return token ? `${token.substring(0, 30)}...` : '';
  };

  return (
    <div className="consultar-container">
      <div className="page-header mb-4">
        <div>
          <h2 className="page-title">API & Consultas</h2>
          <p className="page-subtitle text-muted">Explora la API, descarga ejemplos e interactúa con el SAT</p>
        </div>
      </div>

      <Card className="api-tools-card mb-4 border-0 shadow-sm">
        <Card.Body className="p-4">
          <div className="d-flex align-items-center mb-4">
            <div className="swagger-icon-wrapper me-3">
              <Download size={20} />
            </div>
            <div>
              <h5 className="mb-0">Herramientas de API</h5>
              <small className="text-muted">Explora e integra con la API de SAT Go</small>
            </div>
          </div>

          <div className="mb-4">
            <label className="mb-1 text-muted fw-semibold" style={{ fontSize: '0.9rem' }}>
              Access Token:
            </label>
            <div className="d-flex align-items-center gap-2">
              <input
                type="text"
                value={truncateToken(displayToken)}
                readOnly
                className="form-control me-1"
              />
              <Button variant="outline-secondary" onClick={copyToken} style={{ whiteSpace: 'nowrap' }}>
                Copiar
              </Button>
            </div>
          </div>

          <div className="api-tools-grid">
            {/* Swagger */}
            <div className="api-tool-item api-tool-swagger">
              <div className="api-tool-badge swagger-badge">
                <span>S</span>
              </div>
              <div className="api-tool-content">
                <h6 className="api-tool-name">Swagger UI</h6>
                <p className="api-tool-desc">Interfaz oficial de OpenAPI para explorar, autenticar y probar cada endpoint de la API directamente desde el navegador.</p>
              </div>
              <div className="d-flex gap-2">
                <a
                  href="https://api.sat-go.com/swagger/index.html?urls.primaryName=SAT%20Scraper%20API%20V1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="api-tool-btn btn-swagger-action"
                >
                  v1
                </a>
                <a
                  href="https://api.sat-go.com/swagger/index.html?urls.primaryName=SAT%20Scraper%20API%20V2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="api-tool-btn btn-swagger-action"
                >
                  v2
                </a>
              </div>
            </div>

            {/* Scalar */}
            <div className="api-tool-item api-tool-scalar">
              <div className="api-tool-badge scalar-badge">
                <span>SC</span>
              </div>
              <div className="api-tool-content">
                <h6 className="api-tool-name">Scalar</h6>
                <p className="api-tool-desc">Documentación moderna con diseño limpio, búsqueda integrada y ejemplos de código en múltiples lenguajes por versión.</p>
              </div>
              <div className="d-flex gap-2">
                <a
                  href="https://api.sat-go.com/scalar/v1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="api-tool-btn btn-scalar-action"
                >
                  v1
                </a>
                <a
                  href="https://api.sat-go.com/scalar/v2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="api-tool-btn btn-scalar-action"
                >
                  v2
                </a>
              </div>
            </div>

            {/* Postman */}
            <div className="api-tool-item api-tool-postman">
              <div className="api-tool-badge postman-badge">
                <span>P</span>
              </div>
              <div className="api-tool-content">
                <h6 className="api-tool-name">Postman</h6>
                <p className="api-tool-desc">Guía paso a paso para importar la colección, configurar variables de entorno y consumir la API desde Postman.</p>
              </div>
              <a
                href="https://github.com/hebertpena88/sat-go-cliente/blob/main/README.md"
                target="_blank"
                rel="noopener noreferrer"
                className="api-tool-btn btn-postman-action"
              >
                Ver guía
              </a>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Card className="code-samples-card mb-4 border-0 shadow-sm">
        <Card.Body className="p-4">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="d-flex align-items-center">
              <div className="swagger-icon-wrapper me-3">
                <Code2 size={20} />
              </div>
              <div>
                <h5 className="mb-0">Ejemplos de Código</h5>
                <small className="text-muted">Clientes listos para integrar la API en tu plataforma</small>
              </div>
            </div>
            <a
              href="https://github.com/hebertpena88/sat-go-cliente/archive/refs/heads/main.zip"
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
            >
              <Download size={14} />
              Descargar todo
            </a>
          </div>

          <div className="code-samples-grid">
            <a
              href="https://github.com/hebertpena88/sat-go-cliente/tree/main/net-cliente"
              target="_blank"
              rel="noopener noreferrer"
              className="code-sample-tile tile-dotnet"
            >
              <span className="tile-lang-badge">C#</span>
              <span className="tile-name">.NET</span>
              <span className="tile-action">
                Ver código <Download size={13} />
              </span>
            </a>

            <a
              href="https://github.com/hebertpena88/sat-go-cliente/tree/main/php-cliente"
              target="_blank"
              rel="noopener noreferrer"
              className="code-sample-tile tile-php"
            >
              <span className="tile-lang-badge">PHP</span>
              <span className="tile-name">PHP</span>
              <span className="tile-action">
                Ver código <Download size={13} />
              </span>
            </a>

            <a
              href="https://github.com/hebertpena88/sat-go-cliente/tree/main/python-client"
              target="_blank"
              rel="noopener noreferrer"
              className="code-sample-tile tile-python"
            >
              <span className="tile-lang-badge">PY</span>
              <span className="tile-name">Python</span>
              <span className="tile-action">
                Ver código <Download size={13} />
              </span>
            </a>

            <a
              href="https://github.com/hebertpena88/sat-go-cliente/tree/main/react-cliente"
              target="_blank"
              rel="noopener noreferrer"
              className="code-sample-tile tile-react"
            >
              <span className="tile-lang-badge">JSX</span>
              <span className="tile-name">React</span>
              <span className="tile-action">
                Ver código <Download size={13} />
              </span>
            </a>

            <a
              href="https://github.com/hebertpena88/sat-go-cliente/tree/main/postman"
              target="_blank"
              rel="noopener noreferrer"
              className="code-sample-tile tile-postman-sample"
            >
              <span className="tile-lang-badge">PM</span>
              <span className="tile-name">Postman</span>
              <span className="tile-action">
                Ver colección <Download size={13} />
              </span>
            </a>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Consultar;
